import React from 'react';
import PropTypes from 'prop-types';

export default class ResearchPropertyAsyncSelectOption extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      name: PropTypes.string.isRequired,
      database_name: PropTypes.string
    }).isRequired,
    innerProps: PropTypes.object,
    innerRef: PropTypes.object
  }

  render() {
    const { data, innerProps, innerRef } = this.props;
    return (
      <div ref={innerRef} {...innerProps} className="entity">
        <div>
          <div>
            <strong>{data.name}</strong>
          </div>
          {data.database_name ? (<small>Source: {data.database_name}</small>) : null}
        </div>
      </div>
    );
  }
}
